import app from '../app';
import Model from '../Model';
import PkgLogo from './PkgLogo';
import ActivityTag from './ActivityTag';
import ActivityReward from './ActivityReward';

export default class PkgActivity extends Model {
  pkgLogo() {
    return Model.hasOne<PkgLogo | null>('pkgLogo').call(this);
  }
  pkgId() {
    return Model.attribute<number>('pkgId').call(this);
  }
  name() {
    return Model.attribute<string>('name').call(this);
  }
  discussionId() {
    return Model.attribute<number>('discussionId').call(this);
  }
  type() {
    return Model.attribute<number>('type').call(this);
  }
  // tags() {
  //   return Model.attribute('tags').call(this);
  // }
  // tagId() {
  //   return Model.attribute<number>('tagId').call(this);
  // }
  limitList() {
    return Model.attribute<string>('limitList').call(this);
  }
  parameterList() {
    return Model.attribute<string>('parameterList').call(this);
  }
  // rewards() {
  //   return Model.attribute('rewards').call(this);
  // }
  repeatedReward() {
    return Model.attribute<number>('repeatedReward').call(this);
  }
  startAt() {
    return Model.attribute('startAt', Model.transformDate).call(this);
  }
  endAt() {
    return Model.attribute('endAt', Model.transformDate).call(this);
  }
  activityReward() {
    return Model.hasMany<ActivityReward>('activityReward').call(this);
  }
  activityTag() {
    return Model.hasMany<ActivityTag>('activityTag').call(this);
  }

  isLoading() {
    let currentDate = new Date();
    let startDate = new Date(this.startAt());
    let endDate = new Date(this.endAt());
    if (currentDate.getTime() >= startDate.getTime() && currentDate.getTime() <= endDate.getTime()) {
      return true;
    }
    return false;
  }

  status() {
    let currentDate = new Date();
    let startDate = new Date(this.startAt());
    let endDate = new Date(this.endAt());
    let activityStatus = app.translator.trans('dl-discussionComposer.forum.activity_status.isEnd');
    if (currentDate.getTime() < startDate.getTime()) {
      activityStatus = app.translator.trans('dl-discussionComposer.forum.activity_status.isStart');
    }else if (currentDate.getTime() >= startDate.getTime() && currentDate.getTime() <= endDate.getTime()) {
      activityStatus = app.translator.trans('dl-discussionComposer.forum.activity_status.isLoading');
    }
    return activityStatus;
  }
  

}
